import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { LOGOUT } from '../../constants/actionTypes'
import role from '../../util/role';
import {
  GROUP_LIST_PAGE_LOADED,
  LOG_LIST_PAGE_LOADED
} from '../../constants/actionTypes'
import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'

const mapDispatchToProps = dispatch => ({
  onClickLogout: () => dispatch({ type: LOGOUT }),
})

const Nav = props => {
  // const dashboardClassName = props.selected === 'dashboard' ? 'selected' : 'norm'
  // const directoryClassName = props.selected === 'directory' ? 'selected' : 'norm'
  const filesClassName = props.selected === 'files' ? 'selected' : 'norm'
  const logsClassName = props.selected === 'logs' ? 'selected' : 'norm'
  const groupsClassName = props.selected === 'groups' ? 'selected' : 'norm'
  const settingsClassName = props.selected === 'settings' ? 'selected' : 'norm'

  const userRole = props.currentUser ? (props.currentUser.role || 0) : 0;
  return (
    <Translation>
      {
        (t) => (
          <div id="nav">
            <div id="nav-logo"></div>
            <ul id="menu">
              {/* <li><Link to='/dashboard' className={dashboardClassName}>
          <i className="fad fa-folders"></i>
          <span>Dashboard</span>
        </Link></li>
        <li><Link to='/directory' className={directoryClassName}>
          <i className="fad fa-folders"></i>
          <span>Directory</span>
        </Link></li> */}
              <li><Link to='/files' className={filesClassName}>
                <i className="fad fa-folders"></i>
                <span>{t('nav.files')}</span>
              </Link></li>
              {role.can(userRole, LOG_LIST_PAGE_LOADED) ? <li><Link to='/logs' className={logsClassName}>
                <i className="fad fa-list"></i>
                <span>{t('nav.logs')}</span>
              </Link></li> : null}
              {role.can(userRole, GROUP_LIST_PAGE_LOADED) ? <li><Link to='/groups' className={groupsClassName}>
                <i className="fad fa-users"></i>
                <span>{t('nav.groups')}</span>
              </Link></li> : null}
              <li><Link to='/settings' className={settingsClassName}>
                <i className="fad fa-sliders-v-square"></i>
                <span>{t('nav.settings')}</span>
              </Link></li>
            </ul>
            <div id="nav-last">
              <a href="" onClick={props.onClickLogout}>
                <i className="fad fa-sign-out"></i>
                {t('settings.home_logout_button')}
              </a>
            </div>
          </div>
        )
      }
    </Translation>
  )
}
export default connect(() => ({}), mapDispatchToProps)(Nav)
